<template>
  <div id="admin-accounts">
    <basic-portlet title="Create Timbre Account (Beta)" icon="la la-key">
      <!-- ORGANISATIONS -->
      <FormulateForm
        v-if="showOrgCustUserForms"
        v-model="organisations_form"
        :keep-model-data="true"
        @validation="validationOrganisation = $event">
        <FormulateInput
          key="organisations_group"
          v-slot="{ index }"
          type="group"
          limit="1"
          name="organisations"
          group-repeatable-class="p-5 mb-4 border border-gray-900 shadow-md mt-1"
          add-label="+ Add Organisation">
          <FormulateInput
            key="organisation_name"
            :data-index="index"
            outer-class="mb-4"
            label="Organisation Name"
            input-class="form-control"
            name="organisation_name"
            validation-name="Organisation Name"
            :options="organisationsComp"
            type="autocomplete"
            placeholder="Select an option"
            validation="required"
            @input=" showHideAssignmentForm = false" />
        </FormulateInput>
        <!-- end ORGANISATIONS -->
      </FormulateForm>

      <FormulateForm
        v-if="showOrgCustUserForms"
        v-model="customers_form"
        :keep-model-data="true"
        @validation="validationCustomers = $event">
        <!-- CUSTOMERS -->
        <FormulateInput
          key="customers_group"
          v-slot="{ index }"
          group-repeatable-class="p-5 mb-4 border border-gray-900 shadow-md mt-1"
          type="group"
          name="customers"
          :repeatable="true"
          add-label="+ Add Customer">
          <h3> Customer #{{ index + 1 }} </h3>
          <FormulateInput
            key="customers_name"
            type="text"
            name="customer_name"
            validation-name="Customer Name"
            outer-class="mb-4"
            input-class="form-control"
            label="Customer Name"
            validation-behavior="submit"
            validation="required" />
          <FormulateInput
            key="plans"
            validation-behavior="submit"
            outer-class="mb-4"
            input-class="form-control"
            name="customer_plan"
            :options="plans"
            type="select"
            validation="required"
            label="Pick a plan" />
          <FormulateInput
            key="customer_storage_allocation"
            type="text"
            name="customer_storage_allocation"
            validation-name="Customer Name"
            outer-class="mb-4"
            input-class="form-control"
            label="Storage Allocation"
            value="50"
            validation-behavior="submit"
            validation="required" />
          <FormulateInput
            key="customer_live_feed_limit"
            type="text"
            name="customer_live_feed_limit"
            validation-name="Customer Name"
            outer-class="mb-4"
            input-class="form-control"
            label="Live Feed Limit"
            value="1"
            validation-behavior="submit"
            validation="required" />
          <FormulateInput
            name="customer_ads_enabled"
            type="checkbox"
            label="Ads enabled" />
        </FormulateInput>

        <!-- end CUSTOMERS -->
      </FormulateForm>

      <FormulateForm
        v-if="showOrgCustUserForms"
        v-model="users_form"
        :keep-model-data="true"
        @validation="validationUsers = $event"
        @submit="saveAccount">
        <!-- USERS -->
        <FormulateInput
          v-slot="{ index }"
          key="users_group"
          group-repeatable-class="p-5 mb-4 border border-gray-900 shadow-md mt-1"
          type="group"
          name="users"
          validation-behavior="submit"
          :repeatable="true"
          add-label="+ Add User">
          <h3> User #{{ index + 1 }} </h3>
          <FormulateInput
            data-1p-ignore
            label="Full Name"
            outer-class="mb-4"
            input-class="form-control"
            validation-behavior="submit"
            type="text"
            name="user_name"
            validation-name="User Full Name"
            validation="required" />
          <FormulateInput
            data-1p-ignore
            outer-class="mb-4"
            input-class="form-control"
            type="text"
            name="user_email"
            label="Input the email"
            validation="required|email"
            validation-name="Email Address" />
          <FormulateInput
            name="user_verify_email_on_create"
            type="checkbox"
            label="Verify email on create" />

          <FormulateInput
            :key="`user_${index}`"
            :value="userTypes[2]?.value ?? userTypes[1]?.value ?? userTypes[0]?.value"
            validation="required"
            name="user_type"
            outer-class="mb-4"
            label="Select user type"
            input-class="form-control"
            :options="userTypes"
            type="select" />
        </FormulateInput>
        <!-- end USERS -->
        <br>
      </FormulateForm>

      <div class="button-group">
        <FormulateInput
          v-if="nextStepButtonVisible"
          type="button"
          label="Next Step"
          class="button"
          @click="onNextStepClick" />

        <FormulateInput
          v-if="adjustButtonVisible"
          type="button"
          label="Adjust"
          class="button"
          @click="onAdjustClick" />

        <FormulateInput
          v-if="startOverButtonVisible"
          type="button"
          label="Start Over"
          class="button"
          @click="onStartOverClick" />
      </div>
      <div v-if="showHideAssignmentForm">
        <h1>Assign users to customers</h1>

        <FormulateForm
          v-slot="{ isLoading }"
          v-model="submit_form"
          @submit="saveAccount">
          <div v-for="(x, index) in customers_form.customers" :key="index">
            <FormulateInput
              v-if="x.customer_name"
              :name="`customer_index_${index}`"
              :options="usersAssignOptions"
              type="checkbox"
              :label="x.customer_name" />
          </div>
          <FormulateInput
            key="form_submit"
            input-class="mt-4 btn btn-ss-standout"
            type="submit"
            :disabled="isLoading"
            :label="isLoading ? 'Loading...' : 'Create Account'" />
        </FormulateForm>
      </div>
    </basic-portlet>
  </div>
</template>

<script>

import { handleAxiosError } from "AssetsJs/helpers/responses";
import VueFormulate from '@braid/vue-formulate';
import MyFormulateAutocomplete from "VueComponents/MyFormulateAutocomplete.vue";

Vue.component('MyFormulateAutocomplete', MyFormulateAutocomplete);

Vue.use(VueFormulate, {
  library: {
    autocomplete: {
      classification: 'text',
      component: 'MyFormulateAutocomplete',
    },
  },
});

export default {
  props: {
    organisations: {
      type: Array,
      required: false,
      default: () => (window.organisations),
    },
    plans: {
      type: Array,
      required: false,
      default: () => (window.plans),
    },
    userTypes: {
      type: Array,
      required: false,
      default: () => window.userTypes,
    },
  },
  data: () => ({
    validationOrganisation: {},
    validationCustomers: {},
    validationUsers: {},
    showOrgCustUserForms: true,
    organisations_form: {},
    customers_form: {},
    users_form: {},
    submit_form: {},
    usersAssignOptions: [],
    showHideAssignmentForm: false,
    adjustButtonVisible: false,
    startOverButtonVisible: false,
    upsert: true,
  }),
  computed: {

    nextStepButtonVisible() {
      return this.organisations_form?.organisations?.length > 0 && !this.adjustButtonVisible && !this.startOverButtonVisible;
    },

    // Compute to assign id key as uuid to select input field form
    organisationsComp() {
      _.transform(this.organisations, (_result, value) => {
        value['id'] = value['uuid'];
        return value;
      }, []);

      return this.organisations;
    },
  },

  methods: {

    onNextStepClick() {
      this.showOrgCustUserForms = false;
      this.showHideAssignmentForm = true;
      this.startOverButtonVisible = true;
      this.adjustButtonVisible = true;
      this.submit_form = {};
      this.usersAssignOptions = this.usersAssignOptionsX();
    },

    onStartOverClick() {
      this.organisations_form = {},
      this.customers_form = {},
      this.users_form = {},
      this.submit_form = {};
      this.showOrgCustUserForms = true;
      this.showHideAssignmentForm = false;
      this.startOverButtonVisible = false;
      this.adjustButtonVisible = false;
    },

    onAdjustClick() {
      this.showOrgCustUserForms = true;
      this.showHideAssignmentForm = true;
      this.startOverButtonVisible = false;
      this.adjustButtonVisible = false;
    },

    usersAssignOptionsX() {
      const userCheckboxArr = [];
      this.users_form.users.forEach((user) => {
        if (user.user_name) {
          userCheckboxArr.push(user.user_name);
        }
      });

      return userCheckboxArr;
    },

    async saveAccount() {
      try {
        let payload = {};
        payload = {
          ...this.organisations_form,
          ...this.customers_form,
          ...this.users_form,
          user_assignments: this.submit_form,
          upsert: true,
        };

        const response = await axios.post("/admin/accounts", payload);

        if (response.data.success) {
          toastr.success(response.data?.data?.message ?? 'Success');
        } else {
          toastr.error('Something went wrong');
        }
      } catch (error) {
        if (error.response.status === 422) {
          const errors = error.response.data.errors;
          for (const k in errors) {
            toastr.error(errors[k]);
          }
        } else {
          handleAxiosError(error);
        }
      }
    },
  },
};
</script>

<style lang="scss">
  /* NOT WORKING WITH SCOPED !!! */
  // @use '@braid/vue-formulate/themes/snow/snow.scss' as *;

#admin-accounts {

  .formulate-input-element--button {
    color:red;
  }

  .formulate-input-group-repeatable-remove {
    float: right;
  }

  .formulate-input-dropdown {
    cursor: pointer;
  }

  .list-group-item:hover {
    background: lightgrey;
    font-weight: 500;

  }

  label {
    font-weight: bold;
  }

  .formulate-form-error {
    color:red;
  }

  .formulate-input-errors {
     color:red;
   }

  .formulate-input-help {
      color: gray;
  }

  .formulate-input .formulate-input-element {
    max-width: 100%;
    margin-bottom: 0.1em;
  }

  button {
    background-color: #08708a;
    border-color: #08708a;
    color: var(--white);
    padding: 6px;
  }

// Box inputs
// -----------------------------------------------------------------------------

[data-classification='box'] {
    .formulate-input-wrapper {
      display: flex;
      align-items: center;
    }

    .formulate-input-element {
      overflow: hidden;
      display: flex;
      align-items: center;

      input {
        position: absolute;
        left: -999px;
        opacity: 0;
        pointer-events: none;
      }

      &-decorator {
        display: block;
        width: 1em;
        height: 1em;
        border-radius: .25em;
        border: 1px solid gray;
        position: relative;

        &::before {
          content: '';
          display: block;
          background-size: contain;
          background-position: right;
          width: calc(100% - .125em);
          height: calc(100% - .125em);
          box-sizing: border-box;
          position: absolute;
          top: .0625em;
          left: .0625em;
        }
      }

      &[data-type="radio"] {
        .formulate-input-element-decorator {
          border-radius: 1em;

          &::before {
            border-radius: 1em;
            width: calc(100% - .5em);
            height: calc(100% - .5em);
            top: .25em;
            left: .25em;
          }
        }
      }

      input[type="checkbox"]:checked {
        & ~ .formulate-input-element-decorator {
          border-color: green;

          &::before {
            background-color: green;
            mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M8.76,56.2c-6.38-6.34,3.26-16,9.64-9.69L38,65.88,80.56,23.29c6.38-6.38,16.07,3.32,9.69,9.69L42.84,80.37a6.83,6.83,0,0,1-9.65,0Z"/></svg>');
          }
        }
      }

      input[type="radio"]:checked {
        & ~ .formulate-input-element-decorator {
          border-color: green;

          &::before {
            background-color: green;
          }
        }
      }

      input:focus {
        & ~ .formulate-input-element-decorator {
          border-color: green;
        }
      }
    }

    .formulate-input-label--after {
      margin-left: .5em;
    }

    .formulate-input-label--before {
      margin-right: .5em;
    }
  }

  // -------------------- Input groups -----------------------
  [data-classification='group'] {

      .formulate-input-group-item {
        margin-bottom: .3em;
      }
      & > .formulate-input-wrapper > .formulate-input-label {
        margin-bottom: .3em;
      }
      [data-is-repeatable] {
        padding: 2em;
        .formulate-input-grouping {
          margin: -1em -1em 0 -1em;
        }
        .formulate-input-group-repeatable {

          padding: 1em 3em 1em 1em;
          // border-bottom: 1px solid gray;
          position: relative;
          &:last-child {
            margin-bottom: 1em;
          }
        }
      }
    }

  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

  .form-group label {
    margin-right: 1rem;
    display: flex;
    align-items: center;
    height: 100%;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #2196F3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .button-group {
    display: flex;

  }

  .button {
    margin-right: 1rem;
  }

}
</style>
